// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import DeployingIcon from '../../assets/images/header-lab-bubble-deploying-icon.svg';
import ErrorIcon from '../../assets/images/header-lab-bubble-error-icon.svg';
import CloseIcon from '../../assets/images/cross-icon.svg';
import { getColor } from '../../styled/color';
import { AlertType } from 'react-alert';

const S = {
  SnackbarBubble: styled.div`
    margin-top: 20px;
    padding: 20px;
    display: flex;
    align-items: center;
    background: #434343;
    border-radius: 4px;
    min-width: 390px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  `,
  SnackbarIcon: styled.div<{ type?: AlertType }>`
    margin-right: 17px;
    width: 13px;
    height: 13px;
    ${ props => {
      const type = {
        'error': `background: url(${ErrorIcon});`,
        'info': `
          background: url(${DeployingIcon});
          animation-name: spin;
          animation-duration: 5000ms;
          animation-iteration-count: infinite;
          animation-timing-function: linear;

          @keyframes spin {
              from {
                  transform:rotate(0deg);
              }
              to {
                  transform:rotate(360deg);
              }
          }
        `,
        'success':
          `
            background: #00C6AD;
            border-radius: 50%;
          `
      }
      return props.type && type[props.type]
    }
}`,
  Close: styled.img.attrs({ src: CloseIcon })`
    margin-left: 32px;
    cursor: pointer;
  `,
  SnackbarMessage: styled.div`
    font-size: 16px;
    letter-spacing: 0.29px;
    color: ${getColor('White')};
    max-width: 257px;
    overflow-wrap: break-word;
    margin-right: auto;
  `,
  SnackbarLink: styled.div`
    margin-left: auto;
    font-size: 16px;
    letter-spacing: 0.29px;
    color: ${getColor('Orange')};
    cursor: pointer;
  `
};

export default S;
